<style type="text/css"></style>
<template>
  <div v-if="type == 'defect_search'">
    <el-cascader :style="{ width: width ? width : null }" size="mini" :clearable="clearable" :disabled="disabled" :props="{ multiple: true, value: 'id', label: 'name', emitPath: false, checkStrictly: false }" :placeholder="placeholder" filterable :show-all-levels="showAllLevels" :collapse-tags="true" v-model="id_bind" :options="items" @change="change"></el-cascader>
  </div>
  <div v-else-if="type == 'defect_add'">
    <el-cascader :style="{ width: width ? width : null }" size="mini" :clearable="clearable" :disabled="disabled" :props="{ multiple: false, value: 'id', label: 'name', emitPath: false, checkStrictly: false }" :placeholder="placeholder" filterable :show-all-levels="showAllLevels" :collapse-tags="true" v-model="id_bind" :options="items" @change="change"></el-cascader>
  </div>
  <div v-else-if="type == 'organization'">
    <el-cascader :style="{ width: width ? width : null }" size="mini" :clearable="clearable" :disabled="disabled" :props="{ multiple: multiple, value: 'id', label: 'label', emitPath: false, checkStrictly: true }" :placeholder="placeholder" filterable :show-all-levels="showAllLevels" :collapse-tags="true" v-model="id_bind" :options="items" @change="change"></el-cascader>
  </div>
  <div v-else-if="type == 'sub_organization'">
    <el-cascader :style="{ width: width ? width : null }" size="mini" :clearable="clearable" :disabled="disabled" :props="{ multiple: multiple, value: 'id', label: 'label', emitPath: false, checkStrictly: true }" :placeholder="placeholder" filterable :show-all-levels="showAllLevels" :collapse-tags="true" v-model="id_bind" :options="items" @change="change"></el-cascader>
  </div>
  <div v-else-if="type == 'exception_type'">
    <el-cascader :style="{ width: width ? width : null }" size="mini" :clearable="clearable" :disabled="disabled" :props="{ multiple: multiple, value: 'id', label: 'name', children: 'child', emitPath: false, checkStrictly: false }" :placeholder="placeholder" filterable :show-all-levels="showAllLevels" :collapse-tags="true" v-model="id_bind" :options="items" @change="change"></el-cascader>
  </div>
  <div v-else-if="type == 'pcd'">
    <el-cascader :style="{ width: width ? width : null }" size="mini" :clearable="clearable" :disabled="disabled" :props="{ multiple: multiple, value: 'id', label: 'label', emitPath: false, checkStrictly: true }" :placeholder="placeholder" filterable :show-all-levels="showAllLevels" :collapse-tags="true" v-model="id_bind" :options="items" @change="change"></el-cascader>
  </div>
  <div v-else-if="type == 'warehouse'">
    <el-cascader :style="{ width: width ? width : null }" size="mini" :clearable="clearable" :disabled="disabled" :props="{ multiple: multiple, value: 'id', label: 'label', emitPath: false, checkStrictly: checkStrictly }" :placeholder="placeholder" filterable :show-all-levels="showAllLevels" :collapse-tags="true" v-model="id_bind" :options="items" @change="change"></el-cascader>
  </div>

  <el-select class="selets" v-else filterable :remote="type == 'material2'" :remote-method="type == 'material2' ? remoteMethod : null" :filter-method="type == 'mould' ? dataFilter : null" :clearable="clearable" :style="{ width: width ? width : null }" :disabled="disabled" :multiple-limit="max" v-model="id_bind" :multiple="multiple" collapse-tags :allow-create="false" default-first-option :placeholder="placeholder" @change="change" @visible-change="visibleChange" :reserve-keyword="true">
    <el-option v-if="type == 'equipment' || type == 'equipmentAll'" v-for="item in items" :key="item.id" :label="item.name" :value="item.id">
      <span style="float: left">{{ item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.sn }}</span>
    </el-option>
    <el-option v-if="type == 'material'" v-for="item in items" :key="item.id" :label="item.name + '|' + item.code" :value="item.id">
      <span style="float: left">{{ item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.code }}</span>
    </el-option>
    <el-option v-if="type == 'material2'" v-for="item in items" :key="item.id" :label="item.name + '|' + item.code" :value="item.id">
      <span style="float: left">{{ item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.code + ' | ' + (item.spec != null ? item.spec : '') }}</span>
    </el-option>
    <el-option v-if="type == 'mould'" v-for="item in items" :key="item.id" :label="item.name" :value="item.id">
      <span style="float: left">{{ item.no }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.name + '|' + $t(store.state.dictJsonAll['BASIC_MOULD_STATUS'][item.status]) }}</span>
    </el-option>
    <el-option v-if="type == 'mouth'" v-for="item in items" :key="item.id" :label="item.name" :value="item.id">
      <span style="float: left">{{ item.code }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.name }}</span>
    </el-option>
    <el-option v-if="type == 'craft'" v-for="item in items" :key="item.id" :label="item.code + '|' + item.name" :value="item.id">
      <span style="float: left">{{ item.code }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.name }}</span>
    </el-option>
    <el-option v-if="type == 'tool'" v-for="item in items" :key="item.id" :label="item.toolName" :value="item.id">
      <span style="float: left">{{ item.toolName }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.toolNo }}</span>
    </el-option>

    <el-option v-if="type == 'customer'" v-for="item in items" :key="item.id" :label="item.name" :value="item.id">
      <span style="float: left">{{ item.name }}</span>
    </el-option>
    <el-option v-if="type == 'wms_customer'" v-for="item in items" :key="item.id" :label="item.name" :value="item.id">
      <span style="float: left">{{ item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.code }}</span>
    </el-option>
    <el-option v-if="type == 'supplier'" v-for="item in items" :key="item.id" :label="item.name" :value="item.id">
      <span style="float: left">{{ item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.code }}</span>
    </el-option>
    <el-option v-if="type == 'employee'" v-for="item in items" :key="item.id" :label="item.name" :value="item.id">
      <span style="float: left">{{ item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.jobNo }}</span>
    </el-option>
    <el-option v-if="type == 'customerRole'" v-for="item in items" :key="item.id" :label="item.name" :value="item.id">
      <span style="float: left">{{ item.name }}</span>
    </el-option>
    <el-option v-if="type == 'customer_user'" v-for="item in items" :key="item.id" :label="item.nickname" :value="item.id">
      <span style="float: left">{{ item.nickname }}</span>
    </el-option>
    <el-option v-if="type == 'customer_user2'" v-for="item in items" :key="item.id" :label="item.nickname + ' ' + item.jobNo" :value="item.id">
      <span style="float: left">{{ item.nickname }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.jobNo }}</span>
    </el-option>
    <el-option v-if="type == 'work_procedure'" v-for="item in items" :key="item.id" :label="item.code + '|' + item.desc" :value="item.id">
      <span style="float: left">{{ item.code }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.desc }}</span>
    </el-option>
    <el-option v-if="type == 'skill'" v-for="item in items" :key="item.id" :label="item.skillNo + '|' + item.skillName" :value="item.id">
      <span style="float: left">{{ item.skillNo }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px;margin-right: 20px;">{{ item.skillName }}</span>
    </el-option>
  </el-select>
</template>
<script type="text/javascript">
export default {
  name: 'yi_data_select',
  props: {
    clearable: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    warehouseLevel: {
      type: Number,
      default: 2 //默认三级
    },
    searchText: {
      type: String,
      default: ''
    },
    queryFilter: {
      type: Function,
      default: null
    },
    warehouseType: {
      type: String,
      default: null
    },
    checkStrictly: {
      type: Boolean,
      default: true //填true就是不连带，填false就是只能选叶子
    },
    placeholder: {
      type: String,
      default: function () {
        return this.$t('qingxuanze');
      }
    },

    ids: {},
    showAllLevels: {
      type: Boolean,
      default: false
    },
    idsPath: null,
    max: {
      type: Number,
      default: 999
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    }
  },

  components: {},
  watch: {
    ids(n, o) {
      let tmp = this.id_bind;
      this.id_bind = this.ids;
      if (tmp != this.ids) {
        this.change();
      }
    },
    'store.state.eqs'() {
      if (this.type == 'equipment') {
        //默认查主设备，传 this.query.isAll = true 查所有
        /*this.items = this.store.state.eqs.filter(obj => !obj.belongId).map(item => {
          return item;
        });*/
        this.items = this.store.state.eqs.map(item => {
          return item;
        });
      } else if (this.type == 'equipmentAll') {
        if (this.queryFilter) {
          this.items = this.store.state.eqs.filter(item => {
            return this.queryFilter(item);
          });
        } else {
          this.items = this.store.state.eqs.map(item => {
            return item;
          });
        }
      }
    }
  },
  computed: {},
  data() {
    return {
      items: [],
      id_bind: this.ids,
      filterMoulds: [],
      filterText: ''
    };
  },
  async created() {
    if (this.type == 'equipment') {
      //默认查主设备，传 this.query.isAll = true 查所有
      /* this.items = this.store.state.eqs.filter(obj => !obj.belongId).map(item => {
         return item;
       });*/
      this.items = this.store.state.eqs.map(item => {
        return item;
      });
    } else if (this.type == 'equipmentAll') {
      if (this.queryFilter) {
        this.items = this.store.state.eqs.filter(item => {
          return this.queryFilter(item);
        });
      } else {
        this.items = this.store.state.eqs.map(item => {
          return item;
        });
      }
    } else if (this.type == 'material') {
      let response = await this.http.get('/web/basic/material/page?pageNum=1&pageSize=99999&orderBy=createTime%20desc');
      this.items = response.data.rows.map(item => {
        return item;
      });
    } else if (this.type == 'material2') {
      let params = {
        searchText: this.searchText,
        ids: this.id_bind
      };

      let response = await this.http.post('/web/basic/material/remoteMaterial', params);
      this.items = response.data.map(item => {
        return item;
      });
    } else if (this.type == 'mould') {
      let response = await this.http.get('/web/basic/mould/listByPage?pageNum=1&pageSize=99999');

      this.items = response.data.rows.map(item => {
        return item;
      });
      this.filterMoulds = this.utils.copy(this.items);
    } else if (this.type == 'mouth') {
      if (this.store.state.mouths && this.store.state.mouths.length > 0) {
        this.items = this.store.state.mouths.map(item => {
          return item;
        });
      } else {
        let response = await this.http.get('/web/basic/shooting/mouth/list');
        this.store.commit('SET_MOUTHS', response.data);
        this.items = response.data.map(item => {
          return item;
        });
      }
    } else if (this.type == 'craft') {
      let response = await this.http.get('/web/craft/basic/process/route/page?pageNum=1&pageSize=99999&isComponent=true');
      this.items = response.data.rows.map(item => {
        return item;
      });
    } else if (this.type == 'tool') {
      let response = await this.http.get('/web/tool/list');

      this.items = response.data.map(item => {
        return item;
      });
    } else if (this.type == 'customer') {
      this.items = this.store.state.customers.map(item => {
        return item;
      });
    } else if (this.type == 'wms_customer') {
      this.items = this.store.state.wmsCustomers.map(item => {
        return item;
      });
    } else if (this.type == 'supplier') {
      let response = await this.http.get('/web/supplier/page?pageNum=1&pageSize=999');
      this.items = response.data.rows.map(item => {
        return item;
      });
    } else if (this.type == 'employee') {
      let response = await this.http.get('/web/employee/page?pageNum=1&pageSize=999');
      if (this.queryFilter) {
        this.items = response.data.rows.map(item => {
          return this.queryFilter(item);
        });
      } else {
        this.items = response.data.rows.map(item => {
          return item;
        });
      }
    }
    else if (this.type == 'customerRole') {
      this.items = this.store.state.customerRoles.map(item => {
        return item;
      });
    } else if (this.type == 'organization') {
      this.items = this.store.state.organizations.map(item => {
        return item;
      });
    } else if (this.type == 'sub_organization') {
      this.items = this.store.state.subOrganizations.map(item => {
        return item;
      });
    } else if (this.type == 'exception_type') {
      let response = await this.http.get('/web/andon/exceptionType/tree');
      this.items = response.data.map(item => {
        return this.cleanEmptyChild(item);
      });

    } else if (this.type == 'pcd') {
      this.getPCD = () => {
        this.items = this.store.state.pcds.map(item => {
          return item;
        });
        if (this.items.length == 0) {
          setTimeout(() => {
            this.getPCD();
          }, 1000);
        }
      }
      this.getPCD();


    }


    else if (this.type == 'warehouse') {
      let params = { type: this.warehouseType };
      let response = await this.http.get('web/basic/warehouse/getWarehouseAreaLocation', { params: params });
      this.store.commit('SET_WAREHOUSE', response.data);
      this.items = response.data.map(item => {
        if (this.warehouseLevel == 0) {
          item.children = null;
          return item;
        } else if (this.warehouseLevel == 1) {
          if (item.children != null) {
            for (var i = 0; i < item.children.length; i++) {
              item.children[i].children = null;
            }
          }
          return item;
        } else if (this.warehouseLevel == 2) {
          return item;
        }
      });

      if (this.queryFilter) {
        this.items = this.items.filter(item => {
          return this.queryFilter(item);
        });
      }


    } else if (this.type == 'defect_search' || this.type == 'defect_add') {
      let response = await this.http.get('web/basic/defectType/getDefectTypeTree');
      this.store.commit('SET_DEFECT_TYPES', response.data);
      this.items = response.data.map(item => {
        return item;
      });
    } else if (this.type == 'customer_user') {
      let response = await this.http.get('web/customer/auth/user/page?pageNum=1&pageSize=999');
      this.store.commit('SET_CUSTOMER_USER', response.data.rows);
      this.items = response.data.rows.map(item => {
        return item;
      });
    } else if (this.type == 'customer_user2') {
      let response = await this.http.get('web/customer/auth/user/list/employee/user');
      this.items = response.data.map(item => {
        return item;
      });
    } else if (this.type == 'work_procedure') {
      let response = await this.http.get('web/craft/basic/work/procedure/page?pageNum=1&pageSize=999');
      this.items = response.data.rows.map(item => {
        return item;
      });
    } else if (this.type == 'skill') {
      let response = await this.http.get('web/skill/page?pageNum=1&pageSize=999');
      this.items = response.data.rows.map(item => {
        return item;
      });
    }

    this.change(this.id_bind);

    this.$emit('finishLoad');

  },
  mounted() { },
  methods: {
    cleanEmptyChild(item) {
      // 递归处理子项
      if (item.child && Array.isArray(item.child)) {
        item.child = item.child.map(child => this.cleanEmptyChild(child));
        // 如果child为空数组或null，删除child字段
        if (item.child.length === 0 || item.child === null) {
          delete item.child;
        }
      } else if (item.child === null) {
        delete item.child;
      }
      return item;
    },
    visibleChange(e) {
      console.log(e);
      if (e == false) {
        this.remoteMethod();
      }
    },
    async remoteMethod(val) {
      if (this.items.length == 0 && this.searchText != '') {
        val = this.searchText;
      }
      if (this.type == 'material2') {
        let params = {
          searchText: val,
          ids: this.id_bind
        };
        let response = await this.http.post('/web/basic/material/remoteMaterial', params);
        this.items = response.data.map(item => {
          return item;
        });
      }
    },
    dataFilter(query) {
      this.filterText = query;
      if (this.type == 'mould') {
        if (this.filterText != '') {
          // 存在筛选数组
          this.items = this.filterMoulds.filter(i => {
            // 自己定义何时通过何时不通过
            // 添加多种条件来判断，即自定义搜索方式
            if (i.name.indexOf(this.filterText) != -1 || i.no.indexOf(this.filterText) != -1) {
              return true;
            }
          });
        } else {
          // 不存在还原数组
          this.items = this.utils.copy(this.filterMoulds);
        }
      }

      return true;
    },

    foundParentNode(nodes) {
      let node = null;
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].id == this.id_bind) {
          node = nodes[i];
          return node;
        } else {
          if (nodes[i].children != null) {
            node = this.foundParentNode(nodes[i].children);
            if (node) {
              return node;
            }
          }
        }
      }
      return node;
    },
    makeIds(ids, nodes) {
      for (var i = 0; i < nodes.length; i++) {
        ids.push(nodes[i].id);
        if (nodes[i].children != null) {
          this.makeIds(ids, nodes[i].children);
        }
      }
    },
    change(a, b) {
      console.log(this.ids, this.id_bind);
      if (this.multiple) {
        this.$emit('update:ids', this.id_bind);
      } else {
        this.$emit('update:ids', this.id_bind);
      }
      //如果是组织，那我顺便把父id跟子id都拿出来
      if (this.type == 'organization') {
        let ids = [];
        let parent = this.foundParentNode(this.store.state.organizations);
        if (parent == null) {
          this.$emit('update:idsPath', []);
          this.$emit('update:idsPathParent', []);
          return
        }

        ids.push(parent.id);
        if (parent.children) {
          this.makeIds(ids, parent.children);
        }
        this.$emit('update:idsPath', ids);
      } else if (this.type == 'sub_organization') {
        let ids = [];
        let parent = this.foundParentNode(this.store.state.subOrganizations);
        if (parent == null) {
          this.$emit('update:idsPath', []);
          this.$emit('update:idsPathParent', []);
          return
        }
        ids.push(parent.id);
        if (parent.children) {
          this.makeIds(ids, parent.children);
        }
        this.$emit('update:idsPath', ids);
      } else if (this.type == 'pcd') {
        let ids = [];
        let parent = this.foundParentNode(this.store.state.pcds);
        if (parent == null) {
          this.$emit('update:idsPath', []);
          this.$emit('update:idsPathParent', []);
          return
        }
        ids.push(parent.id);
        if (parent.children) {
          this.makeIds(ids, parent.children);
        }
        this.$emit('update:idsPath', ids);
      } else if (this.type == 'warehouse') {
        let ids = [];
        let parent = this.foundParentNode(this.store.state.warehouses);
        if (parent == null) {
          this.$emit('update:idsPath', []);
          this.$emit('update:idsPathParent', []);
          return
        }

        ids.push(parent.id);
        if (parent.children) {
          this.makeIds(ids, parent.children);
        }
        this.$emit('update:idsPath', ids);

        //向上找idsPath
        let idsParent = this.findPatentValue(this.store.state.warehouses, parent.id, 'id', 'children');
        this.$emit('update:idsPathParent', idsParent);
        console.log(idsParent);
      }

      //如果a是数组，那我需要把a的每个值都找出来
      let selected = null;
      if (Array.isArray(a)) {
        selected = [];
        a.forEach(aa => {
          selected.push(this.items.find(item => {
            return item.id == aa
          }))
        })
      } else {
        selected = this.items.find(item => {
          return item.id == a
        })
      }

      this.$emit('change', a, selected);
    },
    findPatentValue(array, targetId, valueKey, childrenKey) {
      if (!targetId || !Array.isArray(array)) return [];
      const result = [];
      let valid = false;
      const seek = (_array, _targetId) => {
        let parentValue = '';
        const up = (_array_, _targetId_, lastValue) => {
          _array_.forEach(v => {
            const val = v[valueKey];
            const child = v[childrenKey];
            if (val === _targetId_) {
              valid = true;
              parentValue = lastValue;
              return;
            }
            if (child && child.length > 0) {
              up(child, _targetId_, val);
            }
          });
        };
        up(_array, _targetId);
        if (parentValue) {
          result.unshift(parentValue);
          seek(_array, parentValue);
        }
      };
      seek(array, targetId);
      return valid ? [...result, targetId] : [];
    }
  }
};
</script>
